import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form--weight"
export default class extends Controller {
  static targets = ["inputUs", "inputEu"]

  updateWeightUs() {
    this.inputUsTarget.value = this.toLbs(this.inputEuTarget.value)
  }
  updateWeightEu() {
    this.inputEuTarget.value = this.toKg(this.inputUsTarget.value)
  }

  toLbs(n) {
    return Math.round(n * 2.20462)
  }

  toKg(n) {
    return Math.round(n * 0.453592)
  }
}
